import { render, staticRenderFns } from "./ShareFB.vue?vue&type=template&id=f80b4e72&"
import script from "./ShareFB.vue?vue&type=script&lang=js&"
export * from "./ShareFB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports